/** Stable route identifiers — never rename values. */
export const ROUTE_IDS = Object.freeze({
  LOGIN: "HR_ROUTE_001",
  PASSWORD_RESET: "HR_ROUTE_002",

  DASHBOARD_HOME: "HR_ROUTE_010",
  HOTEL_SEARCH: "HR_ROUTE_011",
  HOTEL_RESULTS: "HR_ROUTE_012",
  /** Agent hotel profile from search (en/el dashboard + he legacy). */
  HOTEL_PROFILE: "HR_ROUTE_018",
  SEARCH_OFFER: "HR_ROUTE_013",
  /** Agent hotel room offer / passenger step (en/el hotels/offer + he searchoffer/:id). */
  HOTEL_OFFER: "HR_ROUTE_014",
  FLIGHTS_SEARCH: "HR_ROUTE_025",
  SEARCH_PACKAGES: "HR_ROUTE_015",
  SEARCH_DYNAMIC: "HR_ROUTE_016",
  BOOK_PACKAGE: "HR_ROUTE_017",

  ORDERS_LOBBY: "HR_ROUTE_020",
  REMINDERS: "HR_ROUTE_021",
  AI_SALES_LEADS: "HR_ROUTE_022",
  MANAGEMENT: "HR_ROUTE_023",
  ADMIN_PANEL: "HR_ROUTE_024",

  FINANCE: "HR_ROUTE_030",

  SECURE_CLIENT_ROOT: "HR_ROUTE_040",
  ADMINISTRATION: "HR_ROUTE_041",

  PUBLIC_HOME: "HR_ROUTE_100",
  VACATION_PACKAGES: "HR_ROUTE_101",

  ADMIN_HOME: "HR_ROUTE_200",
});

/** @typedef {typeof ROUTE_IDS[keyof typeof ROUTE_IDS]} RouteId */
